import { render } from "./PartGroup.vue?vue&type=template&id=63d2513e"
import script from "./PartGroup.vue?vue&type=script&lang=js"
export * from "./PartGroup.vue?vue&type=script&lang=js"
script.render = render

export default script